import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Text,
  Divider,
} from '@chakra-ui/react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import { ArrowDownIcon } from '@chakra-ui/icons';
import React, { useRef, useEffect } from 'react';
import { generate } from 'shortid';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import { useWindowSize } from 'react-use';
import House9 from '../assets/houses/house-09.svg';
import House12 from '../assets/houses/house-12.svg';
import FlareGroup5 from '../assets/shapes/shape-group-5.svg';
import FlareGroup9 from '../assets/shapes/shape-group-9.svg';
import FlareGroup6 from '../assets/shapes/shape-group-6.svg';
import {
  LinkOne,
  CalloutPhoneNumber,
  HalfByHalfSection,
  SEO,
} from '../components/_index';

//   We stay in business by getting offers accepted and by helping
// those in need. Our winning formula is made up of giving offers
// you’ll be happy with! We do our best and then some to give you
// the highest possible offer imaginable.

//  The market value of the house (after we fix it up), minus our costs fixing it up (including our profits), will be the offer.
//
//

const seoContent = {
  title: "See how we buy your home - [We're #1 For A Reason]",
  description:
    'We Buy Houses in . We are a local home buying company in and we pay cash for houses. "Sell my house without cleaning or repairing or paying closing costs!"',
};

// Content Blocks
const LeftHeroBlock = () => (
  <Box>
    <Heading
      zIndex="1"
      as="h4"
      size="3xl"
    >
      <span className="highlight">
        {' '}
        Selling Your Home Simply and Hassle Free
      </span>
    </Heading>
    <Heading
      as="h5"
      size="lg"
      variant="sec"
    >
      No Cleaning, No Repairs, and No Commissions!
    </Heading>
    <LinkOne
      mt={4}
      href="#glossary"
      icon={<ArrowDownIcon />}
    >
      Glossary Of Terms
    </LinkOne>
    <LinkOne
      mt={4}
      href="#example"
      icon={<ArrowDownIcon />}
    >
      Real World Example
    </LinkOne>
  </Box>
);

const FlareBlockOne = ({ img }) => (
  <Box
    zIndex="0"
    height={{ base: '15rem', md: '25rem' }}
  >
    <Box
      transform={{ base: 'scale(.8)', md: 'scale(1)' }}
      position="relative"
      width="20rem"
      mx="auto"
      height="15rem"
    >
      <Box
        position="absolute"
        top={{ base: '0%', md: '-20%' }}
        left="20%"
      >
        <FlareGroup6 className="width-400 height-500 width-md-600 height-md-600" />
      </Box>
      <Box
        position="absolute"
        top={{ base: '0%', md: '20%' }}
        left="20%"
      >
        <GatsbyImage
          className="width-300"
          alt="happy home buyers image"
          image={img}
        />
      </Box>
    </Box>
  </Box>
);

const FlareBlockTwo = () => (
  <Box
    zIndex="0"
    className="height-200"
  >
    <Box
      position="relative"
      width="20rem"
      mx="auto"
    >
      <Box
        position="absolute"
        opacity={0.8}
        zIndex="1"
        top="-20%"
        left="-5%"
      >
        <House9 className="width-200 height-300 flip-x" />
      </Box>
      <Box
        position="absolute"
        opacity={0.5}
        top="20%"
        left="0%"
      >
        <FlareGroup5 className="width-500 height-300" />
      </Box>
    </Box>
  </Box>
);

const FlareBlockThree = () => (
  <Box
    zIndex="0"
    className="height-200"
  >
    <Box
      position="relative"
      width="20rem"
      mx="auto"
    >
      <Box
        position="absolute"
        opacity={0.8}
        zIndex="1"
        top="-20%"
        left="-5%"
      >
        <House12 className="width-200 height-300 flip-x" />
      </Box>
      <Box
        position="absolute"
        opacity={0.5}
        top="20%"
        left="0%"
      >
        <FlareGroup9 className="width-500 height-300" />
      </Box>
    </Box>
  </Box>
);

const BehindTheScenesBlock = () => (
  <>
    <Heading
      as="h4"
      size="2xl"
      mb={4}
    >
      What is happening behind the scenes?
    </Heading>
    <Text fontSize="2xl">
      My team and I spend our days doing home analysis so we can get you cash
      for your home in the Bay Area. We mostly spend our time driving to
      properties all over the Bay Area to help homeowners with their selling
      needs, but more importantly, these services are 100% FREE to you! I’ve
      learned that no one will accept a low offer in today's economy, and we
      would have spent so much of our own time, money and effort for nothing.
    </Text>
  </>
);

const StayInBusinessBlock = () => (
  <Heading
    as="h3"
    size="xl"
  >
    We stay in business by getting offers accepted and
    {' '}
    <span className="highlight"> by helping those in need. </span>
    <span className="highlight">
      Our winning formula is made up of giving offers you’ll be happy with!
    </span>
    {' '}
    We do our best and then some to give you the highest possible offer
    imaginable.
  </Heading>
);

const OurOffersBlock = () => (
  <>
    <Heading
      as="h4"
      size="2xl"
      mb={4}
    >
      Our offers are based on your home's
      {' '}
      <span className="highlight">"after repair market value"</span>
    </Heading>
    <Text fontSize="2xl">
      We stay in business by getting offers accepted and by helping those in
      need. Our winning formula is made up of giving offers you’ll be happy
      with! We do our best and then some to give you the highest possible offer
      imaginable.
    </Text>
  </>
);

const WatchOutBlock = () => (
  <>
    <Heading
      as="h4"
      size="2xl"
      mb={4}
    >
      Watch out!
    </Heading>
    <Text fontSize="2xl">
      Many companies don't have your best interests in mind. Most of the time,
      you will receive an inflated offer to discourage you from looking at
      offers from other companies. These companies will have you sign a
      contract, afterwards they will attempt to lower the offer using the
      results of an inspection.
    </Text>
    <Link to="/get-offer">
      <Button
        mt={10}
        variant="btnCTA"
        size="lg"
        isLoading={false}
        type="submit"
      >
        Get Your Free offer
      </Button>
    </Link>
  </>
);

const WeDifferentBlock = () => (
  <>
    <Heading
      as="h4"
      size="2xl"
      mb={4}
    >
      How We're different!
    </Heading>
    <Text fontSize="2xl">
      My team and I spend our days doing home analysis so we can get you cash
      for your home in the Bay Area. We mostly spend our time driving to
      properties all over the Bay Area to help homeowners with their selling
      needs, but more importantly, these services are 100% FREE to you! I’ve
      learned that no one will accept a low offer in today's economy, and we
      would have spent so much of our own time, money and effort for nothing.
    </Text>
    <Link to="/get-offer">
      <Button
        mt={10}
        variant="btnCTA"
        size="lg"
        isLoading={false}
        type="submit"
      >
        Get Your Free offer
      </Button>
    </Link>
  </>
);

const calculation = [
  '[After Repair Value]',
  '- [Cost Of Repairs]',
  '- [Our Selling Costs]',
  '- [Our Minimum Profit]',
];

const exampleValue = [
  'ARV (After Repair Value) = $600k',
  'COR (Cost of Repair) = $80k',
  'Our Selling Cost = 10% * $600k = $60k',
  'Minimum Profit (example) = $40k',
];

const example = ['$600k', '- $80k', '- $60k', '- $40k'];

const Formula = () => (
  <Box
    backgroundColor="brand.five"
    px={4}
    py={10}
    rounded="lg"
  >
    <Flex
      mt={10}
      flexWrap="
            wrap"
    >
      <Text
        fontSize="2xl"
        fontWeight="semibold"
      >
        Your Offer =
      </Text>
      {calculation.map((c, i) => (
        <Text fontSize="2xl">{c}</Text>
      ))}
    </Flex>
    <Divider my={10} />
    <Heading
      as="h5"
      size="lg"
    >
      Example
    </Heading>
    <Flex
      mt={10}
      flexWrap="
            wrap"
      flexDir="column"
    >
      {exampleValue.map((c, i) => (
        <Text
          key={generate()}
          fontSize="2xl"
        >
          {c}
        </Text>
      ))}
      <Divider
        my={4}
        width="40%"
      />
      <Flex
        my={4}
        flexWrap="
            wrap"
      >
        {calculation.map((c, i) => (
          <Text
            key={generate()}
            fontSize="2xl"
          >
            {c}
          </Text>
        ))}
        {' '}
        <Text
          fontSize="2xl"
          fontWeight="semibold"
        >
          {' '}
          = Your Offer
        </Text>
      </Flex>
      <Flex
        flexWrap="
            wrap"
      >
        {example.map((c, i) => (
          <Text
            key={generate()}
            fontSize="2xl"
          >
            {c}
          </Text>
        ))}
        {' '}
        <Text
          fontSize="2xl"
          fontWeight="semibold"
        >
          {' '}
          = $420k
        </Text>
      </Flex>
    </Flex>
  </Box>
);

const terms = [
  {
    term: 'After Repair Value (ARV)',
    definition:
      'This is what the market value of your house will be AFTER we buy and renovate the house.',
  },
  {
    term: 'Cost Of Repairs (COR)',
    definition:
      'This is what our cost will be fixing/updating the house AFTER we purchase it from you.',
  },
  {
    term: 'Our Selling Costs',
    definition:
      'Although we buy houses without involving agents, we on the other hand, have to use an agent to sell that house again AFTER we have purchased it from you and fixed it up. So we have to pay agent fees, closing costs, taxes, holding costs etc. These are all the fees you do NOT have to pay, if you sell your house directly to us! This is usually 10% all together of selling price. (Our Selling Cost = 10% x ARV)',
  },
  {
    term: 'Our Minimum Profit',
    definition:
      'We keep this to an absolute minimum so we can present you with the highest possible offer. See, our business model is structured around making many deals with a little profit per deal, and not a few deals with a huge profit per deal. This benefits all.',
  },
];

const GlossaryOfTerms = () => (
  <Box
    id="glossary"
    pt={20}
  >
    <Heading
      as="h4"
      size="2xl"
      mb={4}
    >
      Glossary Of Terms
    </Heading>

    {terms.map((t, i) => (
      <Box
        py={4}
        px={2}
        backgroundColor={i % 2 ? 'brand.five' : 'gray.200'}
        display="flex"
        alignItems="center"
        key={generate()}
        flexWrap="wrap"
        justifyContent="flex-start"
      >
        <Text
          fontWeight="semibold"
          fontSize="xl"
          mr={4}
        >
          {t.term}
          :
        </Text>
        <Text fontSize="xl">{t.definition}</Text>
      </Box>
    ))}
  </Box>
);

const Example = ({ data }) => {
  const beforeOne = getImage(data.beforeImgOne);
  const afterOne = getImage(data.afterImgOne);

  const exampleOne = [
    // ['As Is Value', '$470K'],
    ['After Repair Value', '$600K'],
    ['Cost of Repairs', '$80K'],
    ['Our Selling Cost', '10% * $600K = $60K'],
    ['Example Minimum Profit', '$40K'],
  ];

  return (
    <Box
      id="example"
      pt={20}
    >
      <Container maxW="container.md">
        <Heading
          as="h3"
          size="2xl"
          mb={4}
        >
          Real World Example
        </Heading>
        <Text
          fontSize="2xl"
          mb={4}
        >
          Imagine that you have a house you want to sell.
        </Text>
        <Text
          fontSize="2xl"
          mb={4}
        >
          Now imagine that your neighbor has the exact same, identical house -
          except for a few upgrades. Maybe some granite countertops, a fresh
          coat of paint, new roof shingles and some new hardwood flooring and
          their house sold for $600,000.
        </Text>
        <Box>
          <GatsbyImage
            className=""
            alt="before renovation image"
            image={beforeOne}
          />
        </Box>
        <Heading
          as="h4"
          mb={4}
          mt={6}
        >
          Now, how does this help us?
        </Heading>
        <Text
          fontSize="2xl"
          mb={4}
        >
          Well, now we know that if make similar upgrades to your house (AFTER
          buying it from you of course), bringing it very close to the condition
          of your neighbor’s home, we would also be able to sell it for $600,000
        </Text>
        <Box mb={6}>
          <GatsbyImage
            className=""
            alt="before renovation image"
            image={afterOne}
          />
        </Box>
        <Text
          fontSize="2xl"
          mb={4}
        >
          So, now that we know the Market value of your home if we fixed it up
          (in this case $600k), and we know the cost of the repairs/upgrades. We
          can now make an offer that works for us. If this offer also works for
          you, we close and you get your money at closing! We make our offers
          based on the market numbers, and find it ethically appalling to make
          an offer based on how desperate you may or may not be able to sell.
        </Text>
        <Box>
          {exampleOne.map((ex, i) => (
            <Flex>
              <Text
                fontWeight="semibold"
                fontSize="xl"
                mr={4}
              >
                {ex[0]}
              </Text>
              <Text fontSize="xl">
                =
                {ex[1]}
              </Text>
            </Flex>
          ))}
          <Divider
            my={4}
            width="40%"
          />
          <Flex
            my={4}
            flexWrap="
            wrap"
          >
            {calculation.map((c, i) => (
              <Text
                key={generate()}
                fontSize="md"
              >
                {c}
              </Text>
            ))}
            {' '}
            <Text
              fontSize="md"
              fontWeight="semibold"
            >
              {' '}
              = Your Offer
            </Text>
          </Flex>
          <Flex
            my={4}
            flexWrap="
            wrap"
          >
            {example.map((c, i) => (
              <Text
                key={generate()}
                fontSize="2xl"
              >
                {c}
              </Text>
            ))}
            {' '}
            <Text
              fontSize="2xl"
              fontWeight="semibold"
            >
              {' '}
              = $420K
            </Text>
          </Flex>
        </Box>
        <Heading
          as="h4"
          mb={4}
          mt={6}
        >
          We do business by the numbers.
        </Heading>
        <Text
          fontSize="2xl"
          mb={4}
        >
          We simply add the numbers and try our best to give you the highest
          possible offer available. We want to make sure that you are happy, and
          from there we can move forward. We are here to make your life better.
        </Text>
      </Container>
    </Box>
  );
};

const HowItWorksPage = ({ location, data }) => {
  const image = getImage(data.flareImage);

  useEffect(() => {
    if (location.hash) {
      const timer = setTimeout(() => {
        const scrollPositionInit = window.scrollY;
        const offSet = window.innerHeight / 4;
        const test = scrollPositionInit - offSet;

        window.scrollTo({
          top: test,
          left: 0,
        });
      }, 900);
      return () => clearTimeout(timer);
    }

    // Logs `HTMLInputElement`
  }, []);

  return (
    <>
      <SEO
        location={location}
        title={seoContent.title}
        description={seoContent.description}
      />
      <main>
        <Container maxW="container.xl">
          <HalfByHalfSection
            py={10}
            left={<LeftHeroBlock />}
            right={<FlareBlockOne img={image} />}
          />
        </Container>
        <Box backgroundColor="brand.five">
          <Container maxW="container.xl">
            <HalfByHalfSection
              reverse
              py={10}
              left={<BehindTheScenesBlock />}
              right={<FlareBlockTwo />}
            />
          </Container>
        </Box>
        <Box backgroundColor="gray.200">
          <Container maxW="container.xl">
            <HalfByHalfSection
              py={10}
              left={<OurOffersBlock />}
              right={<StayInBusinessBlock />}
            />
          </Container>
        </Box>

        {/* <HalfByHalfSection reverse left={<WeDifferentBlock />} right="" /> */}
        <Container maxW="container.xl">
          <HalfByHalfSection
            py={10}
            reverse
            left={<WatchOutBlock />}
            right={<FlareBlockThree />}
          />
        </Container>

        <Container
          maxW="container.xl"
          pt={20}
        >
          <Heading
            as="h3"
            size="3xl"
            mb={4}
          >
            Our Formula
          </Heading>
          <Formula />
          <GlossaryOfTerms />
        </Container>
        <Container maxW="container.xl">
          <Example data={data} />
        </Container>
        <Container maxW="container.xl">
          <CalloutPhoneNumber />
        </Container>
        <Box />
      </main>
    </>
  );
};

export const query = graphql`
  query {
    flareImage: file(relativePath: { eq: "people/women-glasses.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
    beforeImgOne: file(
      relativePath: { eq: "buying-example/6-before-after.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
    afterImgOne: file(relativePath: { eq: "buying-example/after-8.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
  }
`;

export default HowItWorksPage;
